import Immutable from 'seamless-immutable';
import { AutocompleteOrManualAddress } from '@adsk/acs-admin-ui-components-shared-components';
import {
  translateDataToState,
  pickAddressProps,
  getInitialProjectAddress,
} from './utils';
import { ACTIONS } from './actions';

const { ADDRESS_INPUT_MODES } = AutocompleteOrManualAddress;

export const initialState = Immutable.from({
  ui: {
    addressInputMode: ADDRESS_INPUT_MODES.AUTOCOMPLETE,
    autocompletedAddress: null,
    isEditing: false,
    isMapboxTokenActive: false,
    isSaving: false,
    // NOTE: proyectType Fix (must be fixed on the backend)
    localizedType: null,
    missingRequiredField: true,
    projectDataChanged: false,
    showDuplicateNameError: false,
    showModalConfirmation: false,
    showProjectValueError: false,
  },
  data: {
    name: null,
    type: null,
    addressLine1: null,
    addressLine2: null,
    city: null,
    stateOrProvince: null,
    postalCode: null,
    country: null,
    timezone: null,
    jobNumber: null,
    startDate: null,
    endDate: null,
    projectValue: null,
    sourceTemplate: null,
  },
  originalData: null,
});

export const init = (state) => {
  if (state === initialState) {
    return initialState;
  }

  return Immutable.merge(initialState, state, { deep: true });
};

export const reducer = (state, action) => {
  switch (action.type) {
    case ACTIONS.CANCEL_EDIT:
      return state.merge(
        {
          ui: {
            ...initialState.ui.asMutable({ deep: true }),
            autocompletedAddress: getInitialProjectAddress(
              state.originalData.asMutable({ deep: true })
            ),
            isEditing: false,
            // NOTE: proyectType Fix (must be fixed on the backend)
            localizedType: state.ui.localizedType,
          },
          data: { ...state.originalData.asMutable({ deep: true }) },
        },
        { deep: true }
      );
    // NOTE: proyectType Fix (must be fixed on the backend)
    case ACTIONS.FIX_PROJECT_TYPE:
      return state.merge(
        {
          data: {
            type: action.payload,
          },
          originalData: {
            type: action.payload,
          },
        },
        { deep: true }
      );
    case ACTIONS.SET_STATE:
      return init(translateDataToState(action.payload));
    case ACTIONS.SET_MISSING_REQUIRED_FIELD:
      return state.setIn(['ui', 'missingRequiredField'], action.payload);
    case ACTIONS.SET_SHOW_MODAL_CONFIRMATION:
      return state.setIn(['ui', 'showModalConfirmation'], action.payload);
    case ACTIONS.SET_SHOW_PROJECT_VALUE_ERROR:
      return state.setIn(['ui', 'showProjectValueError'], action.payload);
    case ACTIONS.SET_IS_EDITING:
      return state.setIn(['ui', 'isEditing'], action.payload);
    case ACTIONS.SET_SHOW_DUPLICATE_NAME_ERROR:
      return state.setIn(['ui', 'showDuplicateNameError'], action.payload);
    case ACTIONS.SET_MAPBOX_TOKEN_ACTIVE:
      return state.setIn(['ui', 'isMapboxTokenActive'], action.payload);
    case ACTIONS.SET_PROJECT_DATA_CHANGED:
      return state.setIn(['ui', 'projectDataChanged'], action.payload);
    case ACTIONS.SET_ADDRESS_INPUT_MODE:
      return state.setIn(['ui', 'addressInputMode'], action.payload);
    case ACTIONS.SET_AUTOCOMPLETED_ADDRESS:
      return state.setIn(['ui', 'autocompletedAddress'], action.payload);
    case ACTIONS.SET_IS_SAVING:
      return state.setIn(['ui', 'isSaving'], action.payload);
    case ACTIONS.SET_PROJECT_VALUE:
      return state.setIn(['data', 'projectValue', 'value'], action.payload);
    case ACTIONS.SET_CURRENCY:
      return state.setIn(['data', 'projectValue', 'currency'], action.payload);
    case ACTIONS.SET_PROJECT_NAME:
      return state.setIn(['data', 'name'], action.payload);
    case ACTIONS.SET_PROJECT_TYPE:
      return state.setIn(['data', 'type'], action.payload);
    case ACTIONS.SET_ADDRESS:
      return state.merge(
        {
          data: { ...action.payload },
        },
        { deep: true }
      );
    case ACTIONS.RESET_ADDRESS:
      return state.merge(
        {
          ui: {
            autocompletedAddress: null,
          },
          data: {
            ...pickAddressProps(initialState.data.asMutable({ deep: true })),
          },
        },
        { deep: true }
      );
    case ACTIONS.SET_START_DATE:
      return state.setIn(['data', 'startDate'], action.payload);
    case ACTIONS.SET_END_DATE:
      return state.setIn(['data', 'endDate'], action.payload);
    case ACTIONS.SET_JOB_NUMBER:
      return state.setIn(
        ['data', 'jobNumber'],
        action.payload === '' ? null : action.payload
      );
    case ACTIONS.SET_TIMEZONE:
      return state.setIn(['data', 'timezone'], action.payload);
    case ACTIONS.SET_SOURCE_TEMPLATE:
      return state.setIn(['data', 'sourceTemplate'], action.payload);
    default:
      return state;
  }
};
